export const toggleTiendaModal = (setIsTiendaModalOpen) => {
  setIsTiendaModalOpen((prev) => !prev);
};

export const toggleDrawer = (setIsDrawerOpen) => {
  setIsDrawerOpen((prev) => !prev);
};
